import { WebApiService } from './plugins/webApiService';
import FileService from './project-manager/files/services/FileService';
import FolderService from './project-manager/files/services/FolderService';
import VideoService from './project-manager/files/services/VideoService'

export default class apiDataSourceFile {
	/**
	 * * Сервис файлов
	 */
	FileService: FileService;
	/**
	 * * Сервис для работы с папками
	 */
	FolderService: FolderService;
	/**
	 * * Сервис видео
	 */
	VideoService: VideoService;
	constructor(cookieName?: string) {
		this.FileService = new FileService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.FolderService = new FolderService(undefined, cookieName, "appWebSettings.json", "apiUrl");
		this.VideoService = new VideoService(undefined, cookieName, "appWebSettings.json", "apiUrl");
	}

}
